import { Button, Modal, Skeleton } from '@tecsinapse/cortex-react'
import React from 'react'
import { useMoverDialog } from '../hooks/use-mover-dialog'
import useDataToSelect from '../hooks/use-data-to-select'
import { FormProvider, useFormState } from 'react-hook-form'
import { FormSingleSelect } from '../../hook-form-connectors/form-single-select'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { ItemBiblioteca } from '../../../core/types/graphql'

interface MoverDialogProps {
  open: boolean
  close: () => void
  items: ItemBiblioteca[]
}

export const MoverDialog = ({ open, close, items }: MoverDialogProps) => {
  const { form, onSubmit, closeForm } = useMoverDialog({ items, close })

  const { dataToSelect, loading } = useDataToSelect({ items })

  const { handleSubmit, control } = form
  const { isSubmitting, isDirty } = useFormState({ control })

  return (
    <FormProvider {...form}>
      <Modal open={open} onClose={closeForm}>
        <div className={'flex flex-col items-start w-[20rem] space-y-deca'}>
          <p className={'text-h3 font-bold flex w-full'}>
            <Trans>Mover:</Trans>
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className={'w-full'}>
            {loading ? (
              <Skeleton className='w-full h-11 rounded-mili' />
            ) : (
              <FormSingleSelect
                name='novaLocalizacao'
                label={t`Nova Localização`}
                options={dataToSelect?.map(obj => ({
                  value: obj.id,
                  label: obj.nome
                }))}
                disabled={dataToSelect?.length === 0}
                withSearch
              />
            )}
            <div className='flex flex-row items-center justify-between mt-deca flex-1'>
              <Button
                disabled={isSubmitting}
                variants={{ variant: 'outline' }}
                onClick={closeForm}
                type='button'
              >
                <p>
                  <Trans>Cancelar</Trans>
                </p>
              </Button>
              <Button
                type='submit'
                disabled={dataToSelect?.length === 0 || !isDirty}
              >
                <p>
                  <Trans>Mover</Trans>
                </p>
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </FormProvider>
  )
}
